<template>
	<div id="app">
		<v-app id="inspire">
			<Menu v-if="$route.name !== 'Login'" />

			<v-content>
				<v-container fluid style="padding-bottom:50px;">
					<router-view></router-view>

					<v-snackbar
						v-model="alert.active"
						:color="alert.tipe"
						:multi-line="true"
					>
						{{ alert.text }}
						<v-btn text @click="alert.active = false">
							<v-icon>fal fa-times</v-icon>
						</v-btn>
					</v-snackbar>
				</v-container>
			</v-content>
		</v-app>
	</div>
</template>

<script>
import Menu from './components/Menu.vue'

import idb from '@/api/idb'

import { mapState } from 'vuex'

export default {
	components: {
		Menu,
	},
	data() {
		return {
			alert: {
				active: false,
				text: null,
				tipe: null,
			},
		}
	},
	computed: {
		...mapState([
			'authenticated',
			'user',
			'alertMessage',
			'alertType',
			'XMLHttpRequest',
		]),
	},

	watch: {
		alert: {
			deep: true,
			handler(alert) {
				if (alert.active == false) {
					this.GetAlert(undefined, undefined)
				}
			},
		},
		alertMessage(message) {
			if (message !== undefined) {
				this.ShowAlert()
			}
		},
		XMLHttpRequest(value) {
			this.messageXMLHttpRequest(value)
		},
	},

	created() {
		this.blockInspect()
		this.StartiDB()
		this.checkInternet()
	},

	methods: {
		blockInspect() {
			let host = window.location.hostname
			if (host != 'localhost') {
				document.onkeydown = function(e) {
					if (event.keyCode == 123) {
						console.log('You cannot inspect Element')
						return false
					}
					if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
						console.log('You cannot inspect Element')
						return false
					}
					if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
						console.log('You cannot inspect Element')
						return false
					}
					if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
						console.log('You cannot inspect Element')
						return false
					}
					if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
						console.log('You cannot inspect Element')
						return false
					}
				}
				// prevents right clicking
				document.addEventListener('contextmenu', (e) => e.preventDefault())
			}
		},
		checkInternet() {
			let temp = window.navigator.onLine
			this.$store.dispatch('XMLHttpRequest', { value: temp })
			// this.messageXMLHttpRequest(temp)
		},

		messageXMLHttpRequest(value) {
			let message = value === true ? 'Com internet' : 'Sem internet'
			let type = value === true ? 0 : 2
			this.$store.dispatch('alert', {
				alertMessage: message,
				alertType: type,
			})
		},

		StartiDB() {
			idb.createDB()
		},
		GetAlert(alertMessage, alertType) {
			this.$store.dispatch('alert', {
				alertMessage: alertMessage,
				alertType: alertType,
			})
		},
		ShowAlert() {
			this.alert.text = this.alertMessage
			let tipe
			if (this.alertType == 0) {
				tipe = 'success'
			} else if (this.alertType == 1) {
				tipe = 'warning'
			} else {
				tipe = 'error'
			}
			this.alert.tipe = tipe
			this.alert.active = true
		},
	},
}
</script>

<style lang="css">
@media (max-width: 767px) {
	.hide-mobile {
		display: none;
	}
}
/* Line break */
v-list *,
.nl2br {
	white-space: pre-wrap;
	line-height: 1 !important;
}
.v-card__text,
.v-card__subtitle {
	white-space: pre-wrap !important;
}
.v-list-item__title,
.v-list-item__subtitle {
	white-space: pre-wrap !important;
	padding: 5px 0;
}
.btn-square {
	min-width: 40px !important;
}
</style>

<style lang="scss">
// #76AD66 green - green darken-1
// #8C5442 brown - brown darken-1
// Font Awesome5 Pro
$fa-font-path: './assets/font/webfonts';
@import './assets/font/scss/fontawesome';
@import './assets/font/scss/solid'; // fas
@import './assets/font/scss/regular'; // far
@import './assets/font/scss/light'; // far
@import './assets/font/scss/brands'; // fab
@import './assets/font/scss/v4-shims'; // fab
</style>
